import angular from 'angular';

const module = angular.module('whyline.filters.displayHour', []);

const filter = () => (hour) => `${hour[0]}${hour[1]}:${hour[2]}${hour[3]}`;

module.exports = module.filter('displayHour', filter);
